const firebaseConfig = {
  apiKey: "AIzaSyAjCuQM8cGzQLR8189wtIajBgBI0L9ixPw",
  authDomain: "kawasaki-city-kokuho-prd.firebaseapp.com",
  authDomain2: "kawasaki-city-kokuho-prd.appspot.com",
  projectId: "kawasaki-city-kokuho-prd",
  storageBucket: "kawasaki-city-kokuho-prd.appspot.com",
};

export default firebaseConfig;
